import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import React, { useState, useEffect } from 'react';
import "../index.css";
import { Link, useNavigate } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import EditIcon from '@mui/icons-material/Edit';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import Person4Icon from '@mui/icons-material/Person4';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import CloseIcon from '@mui/icons-material/Close';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { IoTriangleOutline } from "react-icons/io5";
import { GrEmptyCircle } from "react-icons/gr";
import Footer from './Common_Components/Footer';
function KanjiQuiz() {
    const questions = [
        {
            question: "What is the reading of さ?",
            options: ["Wa", "Ai", "Sa", "La"],
            correct: 2,
            explanations: [
                "Wa: Incorrect. The correct pronunciation is 'Sa'.",
                "Ai: Incorrect. The correct pronunciation is 'Sa'.",
                "Sa: Correct. This is the correct pronunciation for さ.",
                "La: Incorrect. The correct pronunciation is 'Sa'."
            ]
        },
        {
            question: "What is the reading of き?",
            options: ["Ki", "Go", "Hi", "Ma"],
            correct: 0,
            explanations: [
                "Ki: Correct. This is the correct pronunciation for き.",
                "Go: Incorrect. The correct pronunciation is 'Ki'.",
                "Hi: Incorrect. The correct pronunciation is 'Ki'.",
                "Ma: Incorrect. The correct pronunciation is 'Ki'."
            ]
        },
        {
            question: "What is the reading of く?",
            options: ["Ka", "Ku", "La", "No"],
            correct: 1,
            explanations: [
                "Ka: Incorrect. The correct pronunciation is 'Ku'.",
                "Ku: Correct. This is the correct pronunciation for く.",
                "La: Incorrect. The correct pronunciation is 'Ku'.",
                "No: Incorrect. The correct pronunciation is 'Ku'."
            ]
        },
        {
            question: "What is the reading of し?",
            options: ["So", "Shi", "Ko", "Na"],
            correct: 1,
            explanations: [
                "So: Incorrect. The correct pronunciation is 'Shi'.",
                "Shi: Correct. This is the correct pronunciation for し.",
                "Ko: Incorrect. The correct pronunciation is 'Shi'.",
                "Na: Incorrect. The correct pronunciation is 'Shi'."
            ]
        },
        {
            question: "What is the reading of つ?",
            options: ["Sa", "Fu", "Ts", "Tsu"],
            correct: 3,
            explanations: [
                "Sa: Incorrect. The correct pronunciation is 'Tsu'.",
                "Fu: Incorrect. The correct pronunciation is 'Tsu'.",
                "Ts: Incorrect. The correct pronunciation is 'Tsu'.",
                "Tsu: Correct. This is the correct pronunciation for つ."
            ]
        }
    ];



    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [selectedOption, setSelectedOption] = useState(null);
    const [isCorrect, setIsCorrect] = useState(null);
    const [timer, setTimer] = useState(0); // Start timer from 0
    const [activePage, setActivePage] = useState("Learning");
    const [isSubmitDisabled, setIsSubmitDisabled] = useState(true); // Disable submit initially
    const navigate = useNavigate();
    const [showResultButtons, setShowResultButtons] = useState(false); // Control when to show the new buttons
    const [isAnswerCorrect, setIsAnswerCorrect] = useState(null); // Track whether the answer is correct
    const [explanation, setExplanation] = useState([]);
    
    useEffect(() => {
        const interval = setInterval(() => {
            setTimer((prevTimer) => prevTimer + 1);
        }, 1000);

        return () => clearInterval(interval); // Clean up on unmount
    }, []);

    const formatTime = (timeInSeconds) => {
        const minutes = Math.floor(timeInSeconds / 60);
        const seconds = timeInSeconds % 60;
        return `${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    };

    const handleOptionClick = (index) => {
        setSelectedOption(index); // Set the selected option
        setIsSubmitDisabled(false); // Enable the submit button
    };

    const handleNextQuestion = () => {
        setSelectedOption(null); // Clear selected option
        setIsCorrect(null); // Reset correct/incorrect display
        setIsSubmitDisabled(true); // Disable the submit button for the next question
        setShowResultButtons(false); // Hide the result buttons (Submit/Skip should be visible)
    
        if (currentQuestion < questions.length - 1) {
            setCurrentQuestion(currentQuestion + 1); // Move to the next question
        } else {
            // Navigate to ThankYouQuiz page when the quiz is completed
            navigate('/thank-you-quiz');
        }
    };

    const handleSubmitAnswer = () => {
        if (selectedOption !== null) {
            const correct = selectedOption === questions[currentQuestion].correct;
            setIsCorrect(correct);
            setIsAnswerCorrect(correct);
            setShowResultButtons(true);
    
            // Map options and explanations
            const explanationArr = questions[currentQuestion].options.map((option, index) => ({
                option,
                explanation: questions[currentQuestion].explanations[index]
            }));
            setExplanation(explanationArr);
    
            setIsSubmitDisabled(true); // Disable submit button after submitting
        }
    };
    const progressWidth = ((currentQuestion + 1) / questions.length) * 100;

    return (
        <div className='Profile_Design_Main_Div_11'>
            <div className='header_inner'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <ArrowBackIosIcon onClick={() => navigate(-1)} className='icon_1' />
                            <h2>{showResultButtons ? "Quiz Result" : "Kanji Quiz"}</h2>
                            <ChatBubbleOutlineIcon onClick={() => navigate('/chat-with-staff')} className="logo_1" style={{ cursor: 'pointer', color: '#ffc0cb' }} />
                        </div>
                    </div>
                </div>
            </div>

            <div className="tiles-wrapper">
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className="quiz-container">
                                <div className="quiz-header">
                                    <div className="quiz-info">
                                        <span>{currentQuestion + 1}/{questions.length}</span>
                                    </div>
                                    <div className="quiz-timer">
                                        <span>{formatTime(timer)}</span>
                                    </div>
                                </div>
                                <div className="progress-bar-container" style={{ backgroundColor: 'gray', height: '10px', borderRadius: '5px' }}>
                                    <div
                                        className="progress-bar"
                                        style={{
                                            width: `${progressWidth}%`,
                                            backgroundColor: '#ffc0cb',
                                            height: '100%',
                                            borderRadius: '5px',
                                        }}
                                    ></div>
                                </div>
                                <div className="quiz-question">
                                    <div className="quiz-header">
                                        <h6>Select the correct translation</h6>
                                    </div>
                                    <div className="quiz-question-container">
                                        <img src={`${process.env.PUBLIC_URL}/assets/images/question15.png`} alt="icon" className="question-icon" />
                                        <div className="quiz-question-box">
                                            <h7>{questions[currentQuestion].question}</h7>
                                        </div>
                                    </div>
                                </div>

                                <div className="quiz-options-container">
                                    <div className="quiz-options">
                                        {questions[currentQuestion].options.map((option, index) => (
                                            <button
                                                key={index}
                                                className={`quiz-option ${selectedOption === index
                                                    ? isCorrect === true
                                                        ? 'correct'
                                                        : isCorrect === false
                                                            ? 'incorrect'
                                                            : 'selected'
                                                    : ''
                                                    }`}
                                                onClick={() => handleOptionClick(index)}
                                                disabled={isSubmitDisabled && selectedOption !== null} // Disable options only after submitting
                                            >
                                                {option}
                                                {selectedOption === index && isCorrect === false && (
                                                    <span style={{ color: 'black', marginLeft: '400px', display: 'flex', marginTop: '-20px', alignItems: 'center', fontSize: '14px' }}>
                                                        <CloseIcon style={{ color: 'red', fontSize: '16px', marginRight: '3px' }} />
                                                        Incorrect
                                                    </span>
                                                )}
                                                {selectedOption === index && isCorrect === true && (
                                                    <span style={{ color: 'black', marginLeft: '400px', display: 'flex', marginTop: '-20px', alignItems: 'center', fontSize: '14px' }}>
                                                        <RadioButtonUncheckedIcon style={{ color: 'green', fontSize: '16px', marginRight: '3px' }} />
                                                        Correct
                                                    </span>
                                                )}
                                            </button>
                                        ))}
                                    </div>
                                </div>


                                <div className="quiz-controls">
                                    <div className="quiz-buttons">
                                        {showResultButtons ? (
                                            isAnswerCorrect ? (
                                                <>
                                                    {/* Display Explanation Box */}
                                                    {showResultButtons && (
                                                        <div className="explanation-box">
                                                            <h5>Explanation</h5>
                                                            {explanation.map((item, index) => (
                                                                <div key={index} className="explanation-item">
                                                                    <span>{item.explanation}</span>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}





                                                    {/* Result buttons below explanation box */}
                                                    <div className="result-buttons">
                                                        <button
                                                            className="quiz-submit"
                                                            onClick={() => { console.log('Don’t want to reattempt'); }}
                                                        >
                                                            Don’t want to reattempt
                                                            <div className="reattempt-icon">
                                                                <GrEmptyCircle size={20} color='white' />
                                                            </div>
                                                        </button>

                                                        <button
                                                            className="quiz-submit"
                                                            onClick={() => { console.log('Want to reattempt'); }}
                                                        >
                                                            Want to reattempt
                                                            <div className="want-reattempt-icon">
                                                                <IoTriangleOutline size={20} color='white' />
                                                            </div>
                                                        </button>

                                                        <button
                                                            className="quiz-submit"
                                                            onClick={handleNextQuestion}
                                                        >
                                                            Move to next
                                                        </button>

                                                        <button
                                                            className="quiz-submit"
                                                            onClick={() => { console.log('Back to home'); }}
                                                        >
                                                            Back to home
                                                        </button>
                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    {/* Display Explanation Box */}
                                                    {showResultButtons && (
                                                        <div className="explanation-box">
                                                            <h5>Explanation</h5>
                                                            {explanation.map((item, index) => (
                                                                <div key={index} className="explanation-item">
                                                                    <span>{item.explanation}</span>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}

                                                    {/* Result buttons below explanation box */}
                                                    <div className="result-buttons-incorrect">
                                                        <button
                                                            className="quiz-submit"
                                                            onClick={handleNextQuestion}
                                                        >
                                                            Move to next
                                                        </button>

                                                        <button
                                                            className="quiz-submit"
                                                            onClick={() => { console.log('Back to home'); }}
                                                        >
                                                            Back to home
                                                        </button>
                                                    </div>
                                                </>
                                            )
                                        ) : (
                                            <>
                                                {/* "Skip to Next" button */}
                                                <button
                                                    className="quiz-submit"
                                                    onClick={handleNextQuestion}
                                                    style={{ backgroundColor: 'White' }}
                                                >
                                                    Skip to Next
                                                </button>

                                                {/* "Submit" button */}
                                                <button
                                                    className="quiz-submit"
                                                    onClick={handleSubmitAnswer}
                                                    disabled={isSubmitDisabled}
                                                >
                                                    Submit
                                                </button>
                                            </>
                                        )}
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>
      <Footer />
    </div>
  );
}
export default KanjiQuiz;